// import React, { useState, useEffect, useMemo } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { apiCall } from "../Apis/apiCall";
// import Breadcrumb from "../components/Breadcrumb";
// import CustomSelect from "../components/common/CustomSelect";
// import LoadingComponent from "../components/ui/LoadingComponent";
// import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";

// const AssignPermissions = () => {
//   const [selectedPermissions, setSelectedPermissions] = useState({});
//   const [selectedRoleId, setSelectedRoleId] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [clientRoles, setClientRoles] = useState([]);
//   const [isLoadingRoles, setIsLoadingRoles] = useState(false);
//   const [allPermissions, setAllPermissions] = useState([]);
//   const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
//   const [rolePermissions, setRolePermissions] = useState([]);
//   const [isLoadingRolePermissions, setIsLoadingRolePermissions] =
//     useState(false);
//   const navigate = useNavigate();
//   const [modules, setModules] = useState([]);

//   // Fetch client roles
//   useEffect(() => {
//     const fetchClientRoles = async () => {
//       setIsLoadingRoles(true);
//       try {
//         const response = await apiCall(
//           "get",
//           "/get-all-roles?want_pagination=0&sort_by=role_name&sort_order=asc"
//         );
//         if (!response?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const roles = Array.isArray(response.data.data)
//           ? response.data.data
//           : [];
//         const uniqueRoles = roles.map((role) => ({
//           id: role.role_id,
//           name: role.role_name || `Role ${role.role_id}`,
//         }));
//         setClientRoles(uniqueRoles);
//       } catch (error) {
//         setClientRoles([]);
//       } finally {
//         setIsLoadingRoles(false);
//       }
//     };
//     fetchClientRoles();
//   }, []);

//   // Fetch all permissions and role permissions on role selection
//   useEffect(() => {
//     if (!selectedRoleId) {
//       setAllPermissions([]);
//       setRolePermissions([]);
//       setSelectedPermissions({});
//       setModules([]);
//       return;
//     }
//     const fetchData = async () => {
//       setIsLoadingPermissions(true);
//       setIsLoadingRolePermissions(true);
//       try {
//         const permResponse = await apiCall(
//           "get",
//           "/get-all-user-permissions?want_pagination=0&sort_by=module_name&sort_order=asc"
//         );
//         if (!permResponse?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const permissions = Array.isArray(permResponse.data.data)
//           ? permResponse.data.data
//           : [];
//         setAllPermissions(permissions);
//         const moduleMap = {};
//         permissions.forEach((perm) => {
//           const moduleName = perm.module_name || "General";
//           if (!moduleMap[moduleName]) {
//             moduleMap[moduleName] = { name: moduleName, permissions: [] };
//           }
//           moduleMap[moduleName].permissions.push({
//             permission_key: perm.permission_key,
//             permission_id: perm.permission_id,
//           });
//         });
//         setModules(Object.values(moduleMap));
//         const rolePermResponse = await apiCall(
//           "get",
//           `/get-all-user-permissions-by-role-id/${selectedRoleId}?want_pagination=0`
//         );
//         if (!rolePermResponse?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const rolePerms = Array.isArray(rolePermResponse.data.data)
//           ? rolePermResponse.data.data
//           : [];
//         setRolePermissions(rolePerms);
//       } catch (error) {
//         setAllPermissions([]);
//         setRolePermissions([]);
//         setModules([]);
//       } finally {
//         setIsLoadingPermissions(false);
//         setIsLoadingRolePermissions(false);
//       }
//     };
//     fetchData();
//   }, [selectedRoleId]);

//   // Update selected permissions based on role permissions
//   useEffect(() => {
//     if (!rolePermissions.length && !allPermissions.length) {
//       setSelectedPermissions({});
//       return;
//     }
//     const newSelectedPermissions = {};
//     modules.forEach((module) => {
//       newSelectedPermissions[module.name] = {};
//       module.permissions.forEach((perm) => {
//         const rolePerm = rolePermissions.find(
//           (rp) =>
//             rp.permission_id === perm.permission_id &&
//             rp.is_allowed &&
//             allPermissions.some((p) => p.permission_id === perm.permission_id)
//         );
//         newSelectedPermissions[module.name][perm.permission_key] = !!rolePerm;
//       });
//       newSelectedPermissions[module.name].__main = module.permissions.every(
//         (perm) => newSelectedPermissions[module.name][perm.permission_key]
//       );
//     });
//     setSelectedPermissions(newSelectedPermissions);
//   }, [rolePermissions, modules, allPermissions]);

//   // Handle checkbox change
//   const handleCheckboxChange = (moduleName, permissionKey) => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       newSelected[moduleName] = newSelected[moduleName] || {};
//       newSelected[moduleName][permissionKey] =
//         !newSelected[moduleName][permissionKey];
//       const module = modules.find((m) => m.name === moduleName);
//       if (module) {
//         newSelected[moduleName].__main = module.permissions.every(
//           (perm) => newSelected[moduleName][perm.permission_key]
//         );
//       }
//       return newSelected;
//     });
//   };

//   // Select/deselect all permissions for a module
//   const handleSelectAllPermissions = (moduleName) => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       newSelected[moduleName] = newSelected[moduleName] || {};
//       const module = modules.find((m) => m.name === moduleName);
//       const allSelected = module.permissions.every(
//         (perm) => newSelected[moduleName][perm.permission_key]
//       );
//       module.permissions.forEach((perm) => {
//         newSelected[moduleName][perm.permission_key] = !allSelected;
//       });
//       newSelected[moduleName].__main = !allSelected;
//       return newSelected;
//     });
//   };

//   // Select all modules
//   const handleSelectAllModules = () => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       modules.forEach((module) => {
//         newSelected[module.name] = newSelected[module.name] || {};
//         module.permissions.forEach((perm) => {
//           newSelected[module.name][perm.permission_key] = true;
//         });
//         newSelected[module.name].__main = true;
//       });
//       return newSelected;
//     });
//   };

//   // Deselect all modules
//   const handleDeselectAllModules = () => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       modules.forEach((module) => {
//         newSelected[module.name] = newSelected[module.name] || {};
//         module.permissions.forEach((perm) => {
//           newSelected[module.name][perm.permission_key] = false;
//         });
//         newSelected[module.name].__main = false;
//       });
//       return newSelected;
//     });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedRoleId) {
//       handleCustomResponse("error", "Please select a valid role.");
//       return;
//     }
//     setIsSubmitting(true);
//     const selectedPermissionIds = [];
//     Object.keys(selectedPermissions).forEach((moduleName) => {
//       const module = modules.find((m) => m.name === moduleName);
//       if (module) {
//         Object.keys(selectedPermissions[moduleName]).forEach(
//           (permissionKey) => {
//             if (
//               permissionKey !== "__main" &&
//               selectedPermissions[moduleName][permissionKey]
//             ) {
//               const permission = module.permissions.find(
//                 (perm) => perm.permission_key === permissionKey
//               );
//               if (permission && permission.permission_id) {
//                 selectedPermissionIds.push(permission.permission_id);
//               }
//             }
//           }
//         );
//       }
//     });
//     const uniquePermissionIds = [...new Set(selectedPermissionIds)];
//     try {
//       const assignPayload = {
//         role_id: parseInt(selectedRoleId),
//         permission_ids: uniquePermissionIds,
//       };
//       const response = await apiCall(
//         "post",
//         "/assign-user-permissions",
//         assignPayload
//       );
//       handleApiResponse(
//         response.data,
//         "Permissions assigned successfully!",
//         "POST"
//       );

//       setSelectedRoleId("");
//       setSelectedPermissions({});
//       navigate("/user-permissions");
//     } catch (error) {
//       const err = error.response?.data || error.message;
//       handleApiResponse(err, "Failed to update permissions.", "POST");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Optimize filtered modules with useMemo
//   const filteredModules = useMemo(
//     () => (allPermissions.length > 0 ? modules : []),
//     [allPermissions, modules]
//   );

//   if (isLoadingPermissions || isLoadingRoles) {
//     return (
//       <>
//         <Breadcrumb title={"Assign Permission"} />
//         <LoadingComponent />
//       </>
//     );
//   }
//   return (
//     <>
//       <Breadcrumb title={"Assign Permission"} />
//       <div className="card h-100 p-0 radius-12">
//         <div className="card-body p-40">
//           <form onSubmit={handleSubmit}>
//             <div className="row gy-4">
//               <div className="col-12 col-md-6">
//                 <div className="mb-6">
//                   <label className="form-label fw-semibold text-primary-light text-sm mb-2">
//                     Select Role <span className="text-danger">*</span>
//                   </label>
//                   {isLoadingRoles ? (
//                     <LoadingComponent />
//                   ) : (
//                     <CustomSelect
//                       name="role"
//                       value={selectedRoleId}
//                       onChange={(selected) =>
//                         setSelectedRoleId(selected ? selected.value : "")
//                       }
//                       options={clientRoles.map((role) => ({
//                         label: role.name
//                           .split("_")
//                           .map(
//                             (word) =>
//                               word.charAt(0).toUpperCase() + word.slice(1)
//                           )
//                           .join(" "),
//                         value: role.id,
//                       }))}
//                       placeholder="Select a role"
//                       addNewLabel="Add New Role"
//                       addNewRoute="/all-roles"
//                       isSearchable={true}
//                       isClearable={true}
//                     />
//                   )}
//                   {!isLoadingRoles && clientRoles.length === 0 && (
//                     <span className="text-sm text-danger mt-2 d-block">
//                       No roles available
//                     </span>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12">
//                 {isLoadingPermissions ? (
//                   <LoadingComponent />
//                 ) : selectedRoleId && filteredModules.length === 0 ? (
//                   <span className="text-sm text-danger">
//                     No permissions available. Please check configuration.
//                   </span>
//                 ) : selectedRoleId ? (
//                   <div className="d-flex flex-column gap-3">
//                     <div className="d-flex align-items-center justify-content-between">
//                       <label className="form-label fw-semibold text-primary-light text-sm mb-4 d-block">
//                         Features and Permissions
//                       </label>
//                       <div className="d-flex gap-3">
//                         <button
//                           type="button"
//                           className="text-sm text-blue-600 hover:text-blue-800 transition-all"
//                           onClick={handleSelectAllModules}
//                           disabled={!selectedRoleId}
//                         >
//                           Select All Permissions
//                         </button>
//                         <button
//                           type="button"
//                           className="text-sm text-red-600 hover:text-red-800 transition-all"
//                           onClick={handleDeselectAllModules}
//                           disabled={!selectedRoleId}
//                         >
//                           Deselect All Permissions
//                         </button>
//                       </div>
//                     </div>
//                     {filteredModules.map((module, index) => (
//                       <div
//                         key={index}
//                         className="rounded-lg border border-gray-200 py-3 px-3 mb-4"
//                       >
//                         <div className="d-flex align-items-center justify-content-between mb-4">
//                           <h5 className="text-lg font-bold text-gray-900 tracking-tight">
//                             {module.name}
//                           </h5>
//                           <div className="form-check style-check d-flex align-items-center">
//                             <input
//                               className="form-check-input h-5 w-5 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//                               type="checkbox"
//                               checked={
//                                 !!selectedPermissions[module.name]?.__main
//                               }
//                               onChange={() =>
//                                 handleSelectAllPermissions(module.name)
//                               }
//                             />
//                           </div>
//                         </div>
//                         {module.permissions.length > 0 && (
//                           <div className="ps-4">
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                               <button
//                                 type="button"
//                                 className="text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors duration-200"
//                                 onClick={() =>
//                                   handleSelectAllPermissions(module.name)
//                                 }
//                               ></button>
//                             </div>
//                             <div className="d-flex gap-4 flex-wrap">
//                               {module.permissions.map((perm) => (
//                                 <div
//                                   key={perm.permission_key}
//                                   className="d-flex align-items-center gap-3 py-2"
//                                 >
//                                   <div className="form-check style-check d-flex align-items-center">
//                                     <input
//                                       className="form-check-input h-4 w-4 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//                                       type="checkbox"
//                                       checked={
//                                         !!selectedPermissions[module.name]?.[
//                                           perm.permission_key
//                                         ]
//                                       }
//                                       onChange={() =>
//                                         handleCheckboxChange(
//                                           module.name,
//                                           perm.permission_key
//                                         )
//                                       }
//                                     />
//                                   </div>
//                                   <span className="text-sm font-medium text-gray-700">
//                                     {perm.permission_key
//                                       .split("_")
//                                       .map(
//                                         (word) =>
//                                           word.charAt(0).toUpperCase() +
//                                           word.slice(1)
//                                       )
//                                       .join(" ")}
//                                   </span>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <span className="text-sm text-gray-500">
//                     Please select a role to view assigned permissions
//                   </span>
//                 )}
//               </div>
//               <div className="mt-5 d-flex justify-content-center gap-3">
//                 <CancelButtonForm />
//                 <UpdateButtonForm
//                   disabled={
//                     isSubmitting ||
//                     isLoadingRoles ||
//                     isLoadingPermissions ||
//                     isLoadingRolePermissions 
//                   }
//                 />
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AssignPermissions;










import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import Breadcrumb from "../components/Breadcrumb";
import CustomSelect from "../components/common/CustomSelect";
import LoadingComponent from "../components/ui/LoadingComponent";
import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";
import { handleApiResponse, handleCustomResponse } from "../utils/response";

const AssignPermissions = () => {
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clientRoles, setClientRoles] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);
  const [allPermissions, setAllPermissions] = useState([]);
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
  const [rolePermissions, setRolePermissions] = useState([]);
  const [isLoadingRolePermissions, setIsLoadingRolePermissions] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [modules, setModules] = useState([]);

  // Extract roleId from URL query parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const roleId = params.get("roleId");
    if (roleId) {
      setSelectedRoleId(roleId);
    }
  }, [location]);

  // Fetch client roles
  useEffect(() => {
    const fetchClientRoles = async () => {
      setIsLoadingRoles(true);
      try {
        const response = await apiCall(
          "get",
          "/get-all-roles?want_pagination=0&sort_by=role_name&sort_order=asc"
        );
        if (!response?.data?.data) {
          throw new Error("Invalid response format from server.");
        }
        const roles = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        const uniqueRoles = roles.map((role) => ({
          id: role.role_id.toString(), // Ensure role_id is a string for consistency
          name: role.role_name || `Role ${role.role_id}`,
        }));
        setClientRoles(uniqueRoles);
        console.log("Fetched clientRoles:", uniqueRoles);
      } catch (error) {
        setClientRoles([]);
        setError("Failed to fetch roles.");
        handleCustomResponse("error", "Failed to fetch roles.");
      } finally {
        setIsLoadingRoles(false);
      }
    };
    fetchClientRoles();
  }, []);

  // Validate selectedRoleId after clientRoles is populated
  useEffect(() => {
    if (selectedRoleId && clientRoles.length > 0) {
      const roleExists = clientRoles.find((role) => role.id === selectedRoleId);
      if (!roleExists) {
        setError(`Role with ID ${selectedRoleId} not found.`);
        setSelectedRoleId("");
      }
    }
  }, [clientRoles, selectedRoleId]);

  // Fetch all permissions and role permissions on role selection
  useEffect(() => {
    if (!selectedRoleId) {
      setAllPermissions([]);
      setRolePermissions([]);
      setSelectedPermissions({});
      setModules([]);
      return;
    }
    const fetchData = async () => {
      setIsLoadingPermissions(true);
      setIsLoadingRolePermissions(true);
      try {
        const permResponse = await apiCall(
          "get",
          "/get-all-user-permissions?want_pagination=0&sort_by=module_name&sort_order=asc"
        );
        if (!permResponse?.data?.data) {
          throw new Error("Invalid response format from server.");
        }
        const permissions = Array.isArray(permResponse.data.data)
          ? permResponse.data.data
          : [];
        setAllPermissions(permissions);
        const moduleMap = {};
        permissions.forEach((perm) => {
          const moduleName = perm.module_name || "General";
          if (!moduleMap[moduleName]) {
            moduleMap[moduleName] = { name: moduleName, permissions: [] };
          }
          moduleMap[moduleName].permissions.push({
            permission_key: perm.permission_key,
            permission_id: perm.permission_id,
          });
        });
        setModules(Object.values(moduleMap));
        const rolePermResponse = await apiCall(
          "get",
          `/get-all-user-permissions-by-role-id/${selectedRoleId}?want_pagination=0`
        );
        if (!rolePermResponse?.data?.data) {
          throw new Error("Invalid response format from server.");
        }
        const rolePerms = Array.isArray(rolePermResponse.data.data)
          ? rolePermResponse.data.data
          : [];
        setRolePermissions(rolePerms);
      } catch (error) {
        setAllPermissions([]);
        setRolePermissions([]);
        setModules([]);
        setError("Failed to fetch permissions.");
        handleCustomResponse("error", "Failed to fetch permissions.");
      } finally {
        setIsLoadingPermissions(false);
        setIsLoadingRolePermissions(false);
      }
    };
    fetchData();
  }, [selectedRoleId]);

  // Update selected permissions based on role permissions
  useEffect(() => {
    if (!rolePermissions.length && !allPermissions.length) {
      setSelectedPermissions({});
      return;
    }
    const newSelectedPermissions = {};
    modules.forEach((module) => {
      newSelectedPermissions[module.name] = {};
      module.permissions.forEach((perm) => {
        const rolePerm = rolePermissions.find(
          (rp) =>
            rp.permission_id === perm.permission_id &&
            rp.is_allowed &&
            allPermissions.some((p) => p.permission_id === perm.permission_id)
        );
        newSelectedPermissions[module.name][perm.permission_key] = !!rolePerm;
      });
      newSelectedPermissions[module.name].__main = module.permissions.every(
        (perm) => newSelectedPermissions[module.name][perm.permission_key]
      );
    });
    setSelectedPermissions(newSelectedPermissions);
  }, [rolePermissions, modules, allPermissions]);

  // Handle checkbox change
  const handleCheckboxChange = (moduleName, permissionKey) => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      newSelected[moduleName] = newSelected[moduleName] || {};
      newSelected[moduleName][permissionKey] =
        !newSelected[moduleName][permissionKey];
      const module = modules.find((m) => m.name === moduleName);
      if (module) {
        newSelected[moduleName].__main = module.permissions.every(
          (perm) => newSelected[moduleName][perm.permission_key]
        );
      }
      return newSelected;
    });
  };

  // Select/deselect all permissions for a module
  const handleSelectAllPermissions = (moduleName) => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      newSelected[moduleName] = newSelected[moduleName] || {};
      const module = modules.find((m) => m.name === moduleName);
      const allSelected = module.permissions.every(
        (perm) => newSelected[moduleName][perm.permission_key]
      );
      module.permissions.forEach((perm) => {
        newSelected[moduleName][perm.permission_key] = !allSelected;
      });
      newSelected[moduleName].__main = !allSelected;
      return newSelected;
    });
  };

  // Select all modules
  const handleSelectAllModules = () => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      modules.forEach((module) => {
        newSelected[module.name] = newSelected[module.name] || {};
        module.permissions.forEach((perm) => {
          newSelected[module.name][perm.permission_key] = true;
        });
        newSelected[module.name].__main = true;
      });
      return newSelected;
    });
  };

  // Deselect all modules
  const handleDeselectAllModules = () => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      modules.forEach((module) => {
        newSelected[module.name] = newSelected[module.name] || {};
        module.permissions.forEach((perm) => {
          newSelected[module.name][perm.permission_key] = false;
        });
        newSelected[module.name].__main = false;
      });
      return newSelected;
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRoleId) {
      handleCustomResponse("error", "Please select a valid role.");
      return;
    }
    setIsSubmitting(true);
    const selectedPermissionIds = [];
    Object.keys(selectedPermissions).forEach((moduleName) => {
      const module = modules.find((m) => m.name === moduleName);
      if (module) {
        Object.keys(selectedPermissions[moduleName]).forEach(
          (permissionKey) => {
            if (
              permissionKey !== "__main" &&
              selectedPermissions[moduleName][permissionKey]
            ) {
              const permission = module.permissions.find(
                (perm) => perm.permission_key === permissionKey
              );
              if (permission && permission.permission_id) {
                selectedPermissionIds.push(permission.permission_id);
              }
            }
          }
        );
      }
    });
    const uniquePermissionIds = [...new Set(selectedPermissionIds)];
    try {
      const assignPayload = {
        role_id: parseInt(selectedRoleId),
        permission_ids: uniquePermissionIds,
      };
      const response = await apiCall(
        "post",
        "/assign-user-permissions",
        assignPayload
      );
      handleApiResponse(
        response.data,
        "Permissions assigned successfully!",
        "POST"
      );
      setSelectedRoleId("");
      setSelectedPermissions({});
      navigate("/assign-permissions");
    } catch (error) {
      const err = error.response?.data || error.message;
      handleApiResponse(err, "Failed to update permissions.", "POST");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Map clientRoles to options for CustomSelect
  const roleOptions = useMemo(
    () =>
      clientRoles.map((role) => ({
        label: role.name
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        value: role.id,
      })),
    [clientRoles]
  );

  // Find the selected role option
  const selectedRoleOption = useMemo(
    () => roleOptions.find((option) => option.value === selectedRoleId),
    [roleOptions, selectedRoleId]
  );

  // Debug logging
  useEffect(() => {
    console.log("Debug State:", {
      selectedRoleId,
      clientRoles,
      roleOptions,
      selectedRoleOption,
    });
  }, [selectedRoleId, clientRoles, roleOptions, selectedRoleOption]);

  // Optimize filtered modules with useMemo
  const filteredModules = useMemo(
    () => (allPermissions.length > 0 ? modules : []),
    [allPermissions, modules]
  );

  if (isLoadingPermissions || isLoadingRoles) {
    return (
      <>
        <Breadcrumb title={"Assign Permission"} />
        <LoadingComponent />
      </>
    );
  }

  return (
    <>
      <Breadcrumb title={"Assign Permission"} />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-40">
          {error && (
            <div className="alert alert-danger alert-dismissible fade show mb-3" role="alert">
              {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => setError("")}
              ></button>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="row gy-4">
              <div className="col-12 col-md-6">
                <div className="mb-6">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-2">
                    Select Role <span className="text-danger">*</span>
                  </label>
                  <CustomSelect
                    name="role"
                    value={selectedRoleOption || null}
                    onChange={(selected) =>
                      setSelectedRoleId(selected ? selected.value : "")
                    }
                    options={roleOptions}
                    placeholder="Select a role"
                    addNewLabel="Add New Role"
                    addNewRoute="/all-roles"
                    isSearchable={true}
                    isClearable={true}
                  />
                  {!isLoadingRoles && clientRoles.length === 0 && (
                    <span className="text-sm text-danger mt-2 d-block">
                      No roles available
                    </span>
                  )}
                  {selectedRoleId && !selectedRoleOption && (
                    <span className="text-sm text-danger mt-2 d-block">
                      Selected role (ID: {selectedRoleId}) not found. Please choose another role.
                    </span>
                  )}
                </div>
              </div>
              <div className="col-12">
                {isLoadingPermissions ? (
                  <LoadingComponent />
                ) : selectedRoleId && filteredModules.length === 0 ? (
                  <span className="text-sm text-danger">
                    No permissions available. Please check configuration.
                  </span>
                ) : selectedRoleId ? (
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-4 d-block">
                        Features and Permissions
                      </label>
                      <div className="d-flex gap-3">
                        <button
                          type="button"
                          className="text-sm text-blue-600 hover:text-blue-800 transition-all"
                          onClick={handleSelectAllModules}
                          disabled={!selectedRoleId}
                        >
                          Select All Permissions
                        </button>
                        <button
                          type="button"
                          className="text-sm text-red-600 hover:text-red-800 transition-all"
                          onClick={handleDeselectAllModules}
                          disabled={!selectedRoleId}
                        >
                          Deselect All Permissions
                        </button>
                      </div>
                    </div>
                    {filteredModules.map((module, index) => (
                      <div
                        key={index}
                        className="rounded-lg border border-gray-200 py-3 px-3 mb-4"
                      >
                        <div className="d-flex align-items-center justify-content-between mb-4">
                          <h5 className="text-lg font-bold text-gray-900 tracking-tight">
                            {module.name}
                          </h5>
                          <div className="form-check style-check d-flex align-items-center">
                            <input
                              className="form-check-input h-5 w-5 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                              type="checkbox"
                              checked={
                                !!selectedPermissions[module.name]?.__main
                              }
                              onChange={() =>
                                handleSelectAllPermissions(module.name)
                              }
                            />
                          </div>
                        </div>
                        {module.permissions.length > 0 && (
                          <div className="ps-4">
                            <div className="d-flex gap-4 flex-wrap">
                              {module.permissions.map((perm) => (
                                <div
                                  key={perm.permission_key}
                                  className="d-flex align-items-center gap-3 py-2"
                                >
                                  <div className="form-check style-check d-flex align-items-center">
                                    <input
                                      className="form-check-input h-4 w-4 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                                      type="checkbox"
                                      checked={
                                        !!selectedPermissions[module.name]?.[
                                          perm.permission_key
                                        ]
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(
                                          module.name,
                                          perm.permission_key
                                        )
                                      }
                                    />
                                  </div>
                                  <span className="text-sm font-medium text-gray-700">
                                    {perm.permission_key
                                      .split("_")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" ")}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <span className="text-sm text-gray-500">
                    Please select a role to view assigned permissions
                  </span>
                )}
              </div>
              <div className="mt-5 d-flex justify-content-center gap-3">
                <CancelButtonForm />
                <UpdateButtonForm
                  disabled={
                    isSubmitting ||
                    isLoadingRoles ||
                    isLoadingPermissions ||
                    isLoadingRolePermissions
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AssignPermissions;